
import { Notification } from "../../utils/Notifications/Notification";
import { NOTIFICATION_TYPE } from "../../utils/settings/config";
import { BO_CHON_TAT_CA_DON_HANG_TRANG_DON_SHIP, CHON_TAT_CA_DON_HANG_TRANG_DON_SHIP, CLEAR_EXPORT, RESET_DON_SHIP, SET_DANH_SACH_DON_HANG_TRANG_DON_SHIP, SET_DANH_SACH_DON_SHIP, SET_DANH_SACH_DON_VI_VAN_CHUYEN, SET_DANH_SACH_TINH_TRANG_DON_SHIP, SET_DON_SHIP_EDIT, THEM_DON_HANG_DA_CHON_TRANG_DON_SHIP, THEM_VAO_EXPORT, XOA_DON_HANG_DA_CHON_TRANG_DON_SHIP, XOA_HET_DON_HANG_DA_CHON_TRANG_SON_SHIP, XOA_KHOI_EXPORT } from "../types/DonShipType";
import { SET_DANH_SACH_ORDER, SET_ORDER_EDIT, } from "../types/OderType";

const initialState = {
    danhSachDonShip: [],
    totalCount: 0,
    danhSachDonHangDaChon: [],
    danhSachDonHang: [],
    danhSachTinhTrangDonHang: [
        {
            "Id": 5,
            "Ten": "Hàng đã về, đợi ship"
        },
        {
            "Id": 10,
            "Ten": "Lưu kho đợi thêm đồ/hẹn ngày ship"
        },
        {
            "Id": 8,
            "Ten": "Trả hàng"
        },
    ],
    donShipEdit: {},
    totalCountDanhSachDonHang: 0,
    danhSachDonViVanChuyen: [],
    danhSachTinhTrangDonShip: [],
    danhSachDonShipExport: [],
}

export const DonShipReducer = (state = initialState, action) => {
    switch (action.type) {

        case SET_DANH_SACH_DON_SHIP: {
            state.danhSachDonShip = action.danhSachDonShip;
            state.totalCount = action?.totalCount;
            return { ...state }
        }

        case THEM_DON_HANG_DA_CHON_TRANG_DON_SHIP: {
            const { payload } = action;
            const { danhSachDonHangDaChon } = state;

            if (danhSachDonHangDaChon.length === 0 ||
                danhSachDonHangDaChon[0].IdKhachHang === payload.IdKhachHang) {

                const updatedDanhSach = [...danhSachDonHangDaChon, payload];

                // Sort the list by Id in ascending order
                updatedDanhSach.sort((a, b) => a.Id - b.Id);

                return {
                    ...state,
                    danhSachDonHangDaChon: updatedDanhSach,
                };
            } else {
                Notification(NOTIFICATION_TYPE.error, "không thể thêm đơn hàng của khách hàng khác");
                // Return the current state without any changes if IdKhachHang doesn't match
                return state;
            }
        }

        case THEM_VAO_EXPORT: {
            const { payload } = action;
            const { danhSachDonShipExport } = state;
            const updatedDanhSach = [...danhSachDonShipExport, payload];

            updatedDanhSach.sort((a, b) => -a + b);

            return {
                ...state,
                danhSachDonShipExport: updatedDanhSach
            }
        }

        case XOA_DON_HANG_DA_CHON_TRANG_DON_SHIP:
            return {
                ...state,
                danhSachDonHangDaChon: state.danhSachDonHangDaChon.filter(
                    (order) => order.Id !== action.payload.Id
                ),
            };

        case CHON_TAT_CA_DON_HANG_TRANG_DON_SHIP: {
            // payload: danh sách đơn hàng đã lọc trên bảng chọn
            const { payload } = action;
            const { danhSachDonHangDaChon } = state;

            if (!Array.isArray(payload) || payload.length === 0) {
                return state;
            }

            // Khách hàng ràng buộc: theo đơn đã chọn trước đó (nếu có), nếu chưa có thì theo đơn đầu tiên trong danh sách lọc
            const idKhachHangRangBuoc =
                danhSachDonHangDaChon.length > 0
                    ? danhSachDonHangDaChon[0].IdKhachHang
                    : payload[0].IdKhachHang;

            // Chỉ cho chọn tất cả khi mọi đơn hàng lọc ra cùng một khách hàng
            const cungMotKhachHang = payload.every(
                (donHang) => donHang.IdKhachHang === idKhachHangRangBuoc
            );

            if (!cungMotKhachHang) {
                Notification(
                    NOTIFICATION_TYPE.error,
                    "Chỉ chọn tất cả được khi các đơn hàng cùng một khách hàng"
                );
                return state;
            }

            // Gộp vào danh sách đã chọn, loại trùng theo Id
            const danhSachSauKhiGop = [...danhSachDonHangDaChon];
            payload.forEach((donHang) => {
                if (!danhSachSauKhiGop.some((o) => o.Id === donHang.Id)) {
                    danhSachSauKhiGop.push(donHang);
                }
            });
            danhSachSauKhiGop.sort((a, b) => a.Id - b.Id);

            return {
                ...state,
                danhSachDonHangDaChon: danhSachSauKhiGop,
            };
        }

        case BO_CHON_TAT_CA_DON_HANG_TRANG_DON_SHIP: {
            // idKhachHang: bỏ chọn mọi đơn của khách này (giữ lại đơn sẵn có của đơn ship - is_change)
            // payload: hoặc bỏ chọn đúng các đơn trong danh sách truyền vào
            const { payload, idKhachHang } = action;

            if (idKhachHang !== undefined && idKhachHang !== null) {
                return {
                    ...state,
                    danhSachDonHangDaChon: state.danhSachDonHangDaChon.filter(
                        (order) => order.is_change || order.IdKhachHang !== idKhachHang
                    ),
                };
            }

            const idsCanBoChon = new Set(
                (Array.isArray(payload) ? payload : []).map((donHang) => donHang.Id)
            );

            return {
                ...state,
                danhSachDonHangDaChon: state.danhSachDonHangDaChon.filter(
                    (order) => !idsCanBoChon.has(order.Id)
                ),
            };
        }

        case XOA_KHOI_EXPORT:
            return {
                ...state,
                danhSachDonShipExport: state.danhSachDonShipExport.filter(
                    (Id) => Id !== action.payload
                ),
            };

        case XOA_HET_DON_HANG_DA_CHON_TRANG_SON_SHIP:
            return {
                ...state,
                danhSachDonHangDaChon: [],
            };

        case CLEAR_EXPORT: {
            return {
                ...state,
                danhSachDonShipExport: []
            }
        }

        case SET_DON_SHIP_EDIT: {
            state.danhSachDonHangDaChon = action?.danhSachDonHangDaChon?.sort((a, b) => a.Id - b.Id);
            state.donShipEdit = action?.donShipEdit;

            return { ...state }
        }

        case RESET_DON_SHIP: {
            state.danhSachDonHangDaChon = [];
            state.donShipEdit = {}
            return { ...state }
        }

        case SET_DANH_SACH_DON_HANG_TRANG_DON_SHIP: {
            state.danhSachDonHang = action?.danhSachDonHang;
            state.totalCountDanhSachDonHang = action?.totalCountDanhSachDonHang;
            return { ...state }
        }

        case SET_DANH_SACH_DON_VI_VAN_CHUYEN: {
            state.danhSachDonViVanChuyen = action?.danhSachDonViVanChuyen;
            return { ...state }
        }

        case SET_DANH_SACH_TINH_TRANG_DON_SHIP: {
            state.danhSachTinhTrangDonShip = action?.danhSachTinhTrangDonShip;
            return { ...state }
        }

        default:
            return state
    }
}
